module.exports = __webpack_public_path__ + "78e67ee713c0be20a5174b165bb6f1be.pdf";